module.exports = __webpack_public_path__ + "img/paoduct4.9291a36e.png";